export default __webpack_public_path__ + "static/media/sunny.b4196eab.svg";